import React, { useState, useEffect } from "react";
import { object, string, func } from "prop-types";
import { Link } from "@quintype/components";

import "./menu-item.m.css";

const MenuItem = ({ item, toggleHandler, menuStyle = "menu-link" }) => {
  const [isExternal, setIsExternal] = useState(false);

  useEffect(() => {
    const isExternalLink = (url) => {
      try {
        const linkOrigin = new URL(url).origin;
        return linkOrigin !== window.location.origin;
      } catch (e) {
        return false;
      }
    };

    if (item["item-type"] === "link") {
      setIsExternal(isExternalLink(item.completeUrl));
    }
  }, [item]);

  if (item["item-type"] === "placeholder") {
    return (
      <div styleName="menu-link" className={menuStyle}>
        {item.title}
      </div>
    );
  } else if (item["item-type"] === "link") {
    const target = isExternal ? "_blank" : "_self";
    return (
      <a
        onClick={toggleHandler}
        className={menuStyle}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        href={item.completeUrl || "/"}
        disableAjaxLinks={true}
      >
        {item.title}
      </a>
    );
  } else {
    return (
      <Link
        aria-label="menu-item"
        callback={toggleHandler}
        className={menuStyle}
        href={item.completeUrl || "/"}
        disableAjaxLinks={true}
      >
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: object,
  menuStyle: string,
  toggleHandler: func,
};

export { MenuItem };
